
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/ludic-code",
      function () {
        return require("private-next-pages/archive/ludic-code.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/ludic-code"])
      });
    }
  